/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsSupplier
 */
export interface AssetsMelcoModelsSupplier {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplier
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplier
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplier
     */
    supplier_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSupplier
     */
    publish_state: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSupplier
     */
    created_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSupplier
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSupplier
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsSupplier
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
}

export function AssetsMelcoModelsSupplierFromJSON(json: any): AssetsMelcoModelsSupplier {
    return AssetsMelcoModelsSupplierFromJSONTyped(json, false);
}

export function AssetsMelcoModelsSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'supplier_type': !exists(json, 'supplier_type') ? undefined : json['supplier_type'],
        'publish_state': json['publish_state'],
        'created_date': (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
    };
}

export function AssetsMelcoModelsSupplierToJSON(value?: AssetsMelcoModelsSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'supplier_type': value.supplier_type,
        'publish_state': value.publish_state,
        'created_date': (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
    };
}


